// // import React, { memo, useEffect, useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { useTranslation } from "react-i18next";
// // import AdminCard from "./components/AdminCard";
// // import { getToken } from "../../utils/auth";
// // import { jwtDecode } from "jwt-decode";
// // import axios from "axios";
// // import CONFIG from "../../config";
// // // import WhatsAppAdmin from "./WhatsAppAdmin";
// // // import AIAdmin from "./AIAdmin";

// // const Admin = memo(() => {
// //     const navigate = useNavigate();
// //     const { t, i18n } = useTranslation();
// //     const [permissions, setPermissions] = useState([]);
// //     const [isAdmin, setIsAdmin] = useState(false);
// //     const [loading, setLoading] = useState(true);

// //     const isArabic = i18n.language.startsWith('ar');

// //     useEffect(() => {
// //         const checkPerms = async () => {
// //             const token = getToken();
// //             if (!token) return;
// //             try {
// //                 // Fetch fresh permissions from the dedicated /me endpoint
// //                 const res = await axios.get(`${CONFIG.API_URL}/api/admin/users/me`, {
// //                     headers: { Authorization: `Bearer ${token}` }
// //                 });

// //                 if (res.data) {
// //                     setIsAdmin(!!res.data.isAdmin);
// //                     setPermissions(res.data.permissions || []);

// //                     // Sync with localStorage so ProtectedRoute stays up to date
// //                     const localUser = JSON.parse(localStorage.getItem("user") || "{}");
// //                     localStorage.setItem("user", JSON.stringify({
// //                         ...localUser,
// //                         isAdmin: !!res.data.isAdmin,
// //                         permissions: res.data.permissions || []
// //                     }));
// //                 }
// //             } catch (err) {
// //                 console.error("Failed to fetch fresh permissions:", err);
// //                 // Fallback to token if /me fails
// //                 try {
// //                     const decoded = jwtDecode(token);
// //                     setIsAdmin(!!decoded.isAdmin);
// //                 } catch (e) { }
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };
// //         checkPerms();
// //     }, []);

// //     const hasPerm = (p) => {
// //         if (loading) return false;
// //         if (!isAdmin) return false;
// //         if (permissions.includes('*') || permissions === '*') return true;
// //         return permissions.includes(p);
// //     };

// //     if (loading) return <div className="p-20 text-center animate-pulse">{t('admin.common.loading_admin', 'Loading Admin Panel...')}</div>;

// //     // // Check if WhatsAppAdmin should be shown (full page)
// //     // if (window.location.pathname === '/admin/whatsapp') {
// //     //     return <WhatsAppAdmin />;
// //     // }

// //     // // Check if AIAdmin should be shown (full page)
// //     // if (window.location.pathname === '/admin/ai') {
// //     //     return <AIAdmin />;
// //     // }

// //     return (
// //         <>
// //             <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
// //                 <div className="mb-12 text-center">
// //                     <h1 className="text-5xl font-black text-gray-900 tracking-tight mb-4">{t('admin.title')}</h1>
// //                     <p className="text-gray-500 font-medium text-lg max-w-2xl mx-auto">{t('admin.description')}</p>
// //                 </div>

// //                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
// //                     {/* Analytics & content */}
// //                     {(() => {
// //                         const cards = [
// //                             { perm: 'analytics', title: t('admin.analytics'), onClick: () => navigate("/admin/analytics"), icon: "📊", description: t('admin.card_desc.analytics') },
// //                             { perm: 'users', title: t('admin.users'), onClick: () => navigate("/admin/users"), icon: "👥", description: t('admin.card_desc.users') },
// //                             { perm: 'profile', title: t('admin.profile'), onClick: () => navigate("/admin/profile"), icon: "👤", description: t('admin.card_desc.profile',), alwaysShow: true },
// //                             { perm: '*', title: t('admin.system_logs'), onClick: () => navigate("/admin/logs"), icon: "📜", description: t('admin.card_desc.system-logs') },
// //                             { perm: '*', title: t('admin.admin_secrets'), onClick: () => navigate("/admin/secrets"), icon: "🔐", description: t('admin.card_desc.admin-secrets') },
// //                             { perm: '*', title: t('admin.settings.title', 'System Settings'), onClick: () => navigate("/admin/settings"), icon: "⚙️", description: t('admin.settings.subtitle', 'Unified dashboard for profiles & health') },
// //                             { perm: '*', title: t('admin.tasks.title', 'Background Tasks'), onClick: () => navigate("/admin/tasks"), icon: "📊", description: t('admin.tasks.subtitle', 'Monitor and manage long-running background uploads') }
// //                         ].filter(c => c.alwaysShow || hasPerm(c.perm));

// //                         if (cards.length === 0) return null;

// //                         return (
// //                             <div className="space-y-8">
// //                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
// //                                     {t('admin.overview', 'Overview')}
// //                                 </h3>
// //                                 {cards.map((c, i) => (
// //                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
// //                                 ))}
// //                             </div>
// //                         );
// //                     })()}

// //                     {/* Store Content */}
// //                     {(() => {
// //                         const cards = [
// //                             { perm: 'products', title: t('admin.products'), onClick: () => navigate("/admin/product"), icon: "🛋️", description: t('admin.card_desc.products') },
// //                             { perm: 'hero', title: t('admin.hero'), onClick: () => navigate("/admin/hero"), icon: "🖼️", description: t('admin.card_desc.hero') },
// //                             { perm: 'categories', title: t('admin.categories'), onClick: () => navigate("/admin/categories"), icon: "📂", description: t('admin.card_desc.categories') },
// //                             { perm: 'about', title: t('admin.about'), onClick: () => navigate("/admin/about"), icon: "ℹ️", description: t('admin.card_desc.about') },
// //                             { perm: '*', title: t('admin.legal.title', 'Legal Pages'), onClick: () => navigate("/admin/legal"), icon: "⚖️", description: t('admin.card_desc.legal', 'Manage Privacy Policy and Terms') },
// //                             { perm: '*', title: t('admin.contact_info_title'), onClick: () => navigate("/admin/contact-info"), icon: "📞", description: t('admin.card_desc.contact_info') },
// //                             { perm: '*', title: t('admin.trash', 'Trash'), onClick: () => navigate("/admin/trash"), icon: "🗑️", description: t('admin.card_desc.trash', 'Restore or permanently delete items') },
// //                             { perm: '*', title: 'Orders', onClick: () => navigate("/admin/orders"), icon: "📦", description: 'Manage customer orders, track status and revenue' },
// //                             { perm: '*', title: 'Wishlist Insights', onClick: () => navigate("/admin/wishlist-insights"), icon: "❤️", description: 'See which products customers save most' },
// //                             { perm: '*', title: 'Cart Insights', onClick: () => navigate("/admin/cart-insights"), icon: "🛒", description: 'View active shopping carts and estimated value' },
// //                         ].filter(c => hasPerm(c.perm));

// //                         if (cards.length === 0) return null;

// //                         return (
// //                             <div className="space-y-8">
// //                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
// //                                     {t('admin.store_content', 'Store Content')}
// //                                 </h3>
// //                                 {cards.map((c, i) => (
// //                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
// //                                 ))}
// //                             </div>
// //                         );
// //                     })()}

// //                     {/* Customer Interaction */}
// //                     {(() => {
// //                         const cards = [
// //                             { perm: 'messages', title: t('admin.messages'), onClick: () => navigate("/admin/messages"), icon: "💬", description: t('admin.card_desc.messages', 'Contact requests') },
// //                             { perm: 'reviews', title: t('admin.reviews'), onClick: () => navigate("/admin/reviews"), icon: "⭐", description: t('admin.card_desc.reviews', 'Product ratings') },
// //                             { perm: 'feedback', title: t('admin.feedback'), onClick: () => navigate("/admin/feedback"), icon: "📝", description: t('admin.card_desc.feedback', 'General feedback') },
// //                             { perm: '*', title: 'WhatsApp AI', onClick: () => navigate("/admin/whatsapp"), icon: "📱", description: 'Configure WhatsApp auto-replies with AI' },
// //                             { perm: '*', title: 'AI Configuration', onClick: () => navigate("/admin/ai"), icon: "🤖", description: 'Configure AI providers and settings' },
// //                             { perm: '*', title: 'Magic Writer', onClick: () => navigate("/admin/magic-writer"), icon: "✨", description: 'AI-powered writing assistant for content creation' },
// //                             { perm: '*', title: t('admin.instructions.title', 'Instructions'), onClick: () => navigate("/admin/instructions"), icon: "📖", description: t('admin.instructions.description', 'Guidelines for domain owners') }
// //                         ].filter(c => hasPerm(c.perm));

// //                         if (cards.length === 0) return null;

// //                         return (
// //                             <div className="space-y-8">
// //                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
// //                                     {t('admin.feedback_section', 'Feedback')}
// //                                 </h3>
// //                                 {cards.map((c, i) => (
// //                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
// //                                 ))}
// //                             </div>
// //                         );
// //                     })()}

// //                     {/* Master Admin Operations */}
// //                     {(() => {
// //                         const cards = [
// //                             { perm: '*', title: t('admin.contracts.title', 'Contracts & Sales'), onClick: () => navigate("/admin/contracts"), icon: "📄", description: t('admin.contracts.description', 'Manage work contracts and create buyer accounts') }
// //                         ].filter(c => hasPerm(c.perm));

// //                         if (cards.length === 0) return null;

// //                         return (
// //                             <div className="space-y-8">
// //                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
// //                                     {t('admin.sales_section', 'Sales & Operations')}
// //                                 </h3>
// //                                 {cards.map((c, i) => (
// //                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
// //                                 ))}
// //                             </div>
// //                         );
// //                     })()}
// //                 </div>
// //             </div >
// //         </>
// //     )
// // });

// // export default Admin;








// // ====================================
// // New work isMaster
// // ====================================




// import React, { memo, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import AdminCard from "./components/AdminCard";
// import { getToken, getUser } from "../../utils/auth";
// import { jwtDecode } from "jwt-decode";
// import axios from "axios";
// import CONFIG from "../../config";
// import { Helmet } from "react-helmet-async";
// import SEO from "../../components/common/SEO";
// // import WhatsAppAdmin from "./WhatsAppAdmin";
// // import AIAdmin from "./AIAdmin";
// // Import AdminUsers component
// // import AdminUsers from "./AdminUsers";

// const Admin = memo(() => {
//     const navigate = useNavigate();
//     const { t, i18n } = useTranslation();
//     const [permissions, setPermissions] = useState([]);
//     const [isAdmin, setIsAdmin] = useState(false);
//     const [isMaster, setIsMaster] = useState(false);
//     const [loading, setLoading] = useState(true);

//     const isArabic = i18n.language.startsWith('ar');

//     useEffect(() => {
//         const MASTER_PROFILE_ID = 'prof_01JK0000000000000000000001';
//         const computeIsMaster = (data) => {
//             const perms = data.permissions || [];
//             const hasStar = Array.isArray(perms) ? perms.includes('*') : perms === '*';
//             return hasStar && (!data.profile_id || data.profile_id === MASTER_PROFILE_ID);
//         };

//         const checkPerms = async () => {
//             const token = getToken();
//             if (!token) return;
//             try {
//                 // Fetch fresh permissions from the dedicated /me endpoint
//                 const res = await axios.get(`${CONFIG.API_URL}/api/admin/users/me`, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });

//                 if (res.data) {
//                     const master = computeIsMaster(res.data);
//                     setIsAdmin(!!res.data.isAdmin);
//                     setIsMaster(master);
//                     setPermissions(res.data.permissions || []);

//                     // Sync with localStorage so ProtectedRoute & Header stay up to date
//                     const localUser = JSON.parse(localStorage.getItem("user") || "{}");
//                     localStorage.setItem("user", JSON.stringify({
//                         ...localUser,
//                         isAdmin: !!res.data.isAdmin,
//                         isMaster: master,
//                         permissions: res.data.permissions || []
//                     }));
//                     // Notify Header (and any other listener) about the updated user
//                     window.dispatchEvent(new Event('user_changed'));
//                 }
//             } catch (err) {
//                 console.error("Failed to fetch fresh permissions:", err);
//                 if (err.response && err.response.status === 401) {
//                     // Unauthorized – redirect to login page
//                     navigate('/login');
//                     return;
//                 }
//                 // Fallback to token if /me fails
//                 try {
//                     const decoded = jwtDecode(token);
//                     setIsAdmin(!!decoded.isAdmin);
//                 } catch (e) { }
//             } finally {
//                 setLoading(false);
//             }
//         };
//         checkPerms();
//     }, []);

//     const hasPerm = (p) => {
//         if (loading) return false;
//         if (!isAdmin) return false;
//         if (permissions.includes('*') || permissions === '*') return true;
//         return permissions.includes(p);
//     };


//     useEffect(() => {
//         const check = () => {
//             try {
//                 const u = getUser();
//                 // setUserState(u);
//                 setIsMaster(!!u?.isMaster);
//             } catch (e) {
//                 // setUserState(null);
//                 setIsMaster(false);
//             }
//         };

//         check();

//         // const onStorage = (e) => {
//         //   if (e.key === 'user') check();
//         // };

//         const onCustom = () => check();

//         // window.addEventListener('storage', onStorage);
//         window.addEventListener('user_changed', onCustom);
//         return () => {
//             // window.removeEventListener('storage', onStorage);
//             window.removeEventListener('user_changed', onCustom);
//         };
//     }, []);

//     if (loading) return <div className="p-20 text-center animate-pulse">{t('admin.common.loading_admin', 'Loading Admin Panel...')}</div>;

//     // // Check if WhatsAppAdmin should be shown (full page)
//     // if (window.location.pathname === '/admin/whatsapp') {
//     //     return <WhatsAppAdmin />;
//     // }

//     // // Check if AIAdmin should be shown (full page)
//     // if (window.location.pathname === '/admin/ai') {
//     //     return <AIAdmin />;
//     // }

//     return (
//         <>
//             <Helmet>
//                 <html lang={isArabic ? 'ar' : 'en'} dir={isArabic ? 'rtl' : 'ltr'} />
//             </Helmet>
//             <SEO />
//             <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
//                 <div className="mb-12 text-center">
//                     <h1 className="text-5xl font-black text-gray-900 tracking-tight mb-4">{t('admin.title')}</h1>
//                     <p className="text-gray-500 font-medium text-lg max-w-2xl mx-auto">{t('admin.description')}</p>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                     {/* Analytics & content */}
//                     {(() => {
//                         const cards = [
//                             { perm: 'analytics', title: t('admin.analytics'), onClick: () => navigate("/admin/analytics"), icon: "📊", description: t('admin.card_desc.analytics') },
//                             { perm: 'users', title: t('admin.users'), onClick: () => navigate("/admin/users"), icon: "👥", description: t('admin.card_desc.users') },
//                             { perm: 'profile', title: t('admin.profile'), onClick: () => navigate("/admin/profile"), icon: "👤", description: t('admin.card_desc.profile',), alwaysShow: true },
//                             { perm: '*', title: t('admin.system_logs'), onClick: () => navigate("/admin/logs"), icon: "📜", description: t('admin.card_desc.system-logs') },
//                             { perm: '*', title: t('admin.admin_secrets'), onClick: () => navigate("/admin/secrets"), icon: "🔐", description: t('admin.card_desc.admin-secrets') },
//                             { perm: '*', title: t('admin.breach_logs', 'Data Breach Logs'), onClick: () => navigate("/admin/compliance/breaches"), icon: "🚨", description: t('admin.breach_subtitle', '72-Hour Transparency Compliance Audit Trail') },
//                             { perm: '*', title: t('admin.settings.title', 'System Settings'), onClick: () => navigate("/admin/settings"), icon: "⚙️", description: t('admin.settings.subtitle', 'Unified dashboard for profiles & health') },
//                             { perm: '*', title: t('admin.tasks.title', 'Background Tasks'), onClick: () => navigate("/admin/tasks"), icon: "📊", description: t('admin.tasks.subtitle', 'Monitor and manage long-running background uploads') },
//                             { perm: '*', title: t('admin.data_subject_rights', 'Data Subject Rights'), onClick: () => navigate("/admin/compliance/data-subject"), icon: "🛡️", description: t('admin.data_subject_rights_desc', 'Manage user data access, rectification, erasure, consent & breach notifications') }
//                         ].filter(c => c.alwaysShow || hasPerm(c.perm));

//                         if (cards.length === 0) return null;

//                         return (
//                             <div className="space-y-8">
//                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
//                                     {t('admin.overview', 'Overview')}
//                                 </h3>
//                                 {cards.map((c, i) => (
//                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
//                                 ))}
//                             </div>
//                         );
//                     })()}

//                     {/* Store Content */}
//                     {(() => {
//                         const cards = [
//                             { perm: 'products', title: t('admin.products'), onClick: () => navigate("/admin/product"), icon: "🛋️", description: t('admin.card_desc.products') },
//                             { perm: 'hero', title: t('admin.hero'), onClick: () => navigate("/admin/hero"), icon: "🖼️", description: t('admin.card_desc.hero') },
//                             { perm: 'categories', title: t('admin.categories'), onClick: () => navigate("/admin/categories"), icon: "📂", description: t('admin.card_desc.categories') },
//                             { perm: 'about', title: t('admin.about'), onClick: () => navigate("/admin/about"), icon: "ℹ️", description: t('admin.card_desc.about') },
//                             { perm: '*', title: t('admin.legal.title', 'Legal Pages'), onClick: () => navigate("/admin/legal"), icon: "⚖️", description: t('admin.card_desc.legal', 'Manage Privacy Policy and Terms') },
//                             { perm: '*', title: t('admin.contact_info_title'), onClick: () => navigate("/admin/contact-info"), icon: "📞", description: t('admin.card_desc.contact_info') },
//                             { perm: '*', title: t('admin.trash', 'Trash'), onClick: () => navigate("/admin/trash"), icon: "🗑️", description: t('admin.card_desc.trash', 'Restore or permanently delete items') },
//                             { perm: '*', title: 'Orders', onClick: () => navigate("/admin/orders"), icon: "📦", description: 'Manage customer orders, track status and revenue' },
//                             { perm: '*', title: 'Wishlist Insights', onClick: () => navigate("/admin/wishlist-insights"), icon: "❤️", description: 'See which products customers save most' },
//                             { perm: '*', title: 'Cart Insights', onClick: () => navigate("/admin/cart-insights"), icon: "🛒", description: 'View active shopping carts and estimated value' },
//                         ].filter(c => hasPerm(c.perm));

//                         if (cards.length === 0) return null;

//                         return (
//                             <div className="space-y-8">
//                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
//                                     {t('admin.store_content', 'Store Content')}
//                                 </h3>
//                                 {cards.map((c, i) => (
//                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
//                                 ))}
//                             </div>
//                         );
//                     })()}

//                     {/* Customer Interaction */}
//                     {(() => {
//                         const cards = [
//                             { perm: 'messages', title: t('admin.messages'), onClick: () => navigate("/admin/messages"), icon: "💬", description: t('admin.card_desc.messages', 'Contact requests') },
//                             { perm: 'reviews', title: t('admin.reviews'), onClick: () => navigate("/admin/reviews"), icon: "⭐", description: t('admin.card_desc.reviews', 'Product ratings') },
//                             { perm: 'feedback', title: t('admin.feedback'), onClick: () => navigate("/admin/feedback"), icon: "📝", description: t('admin.card_desc.feedback', 'General feedback') },
//                             { perm: '*', title: 'WhatsApp AI', onClick: () => navigate("/admin/whatsapp"), icon: "📱", description: 'Configure WhatsApp auto-replies with AI' },
//                             { perm: '*', title: 'AI Configuration', onClick: () => navigate("/admin/ai"), icon: "🤖", description: 'Configure AI providers and settings' },
//                             { perm: '*', title: 'Magic Writer', onClick: () => navigate("/admin/magic-writer"), icon: "✨", description: 'AI-powered writing assistant for content creation' },
//                             { perm: '*', title: t('admin.instructions.title', 'Instructions'), onClick: () => navigate("/admin/instructions"), icon: "📖", description: t('admin.instructions.description', 'Guidelines for domain owners') },
//                             { perm: '*', title: t('admin.communication_channel'), onClick: () => navigate("/admin/compliance/communication-channel"), icon: "📡", description: t('admin.card_desc.communication_channel', 'Generate public communication channel IDs') },
//                             { perm: '*', title: t('admin.channel_wizard'), onClick: () => navigate("/admin/channel-wizard"), icon: "🪄", description: t('admin.card_desc.channel_wizard', 'Create a new communication channel') }
//                         ].filter(c => hasPerm(c.perm));

//                         if (cards.length === 0) return null;

//                         return (
//                             <div className="space-y-8">
//                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
//                                     {t('admin.feedback_section', 'Feedback')}
//                                 </h3>
//                                 {cards.map((c, i) => (
//                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
//                                 ))}
//                             </div>
//                         );
//                     })()}

//                     {/* Master Admin Operations */}
//                     {isMaster && (() => {
//                         const cards = [
//                             { perm: '*', title: t('admin.contracts.title', 'Contracts & Sales'), onClick: () => navigate("/admin/contracts"), icon: "📄", description: t('admin.contracts.description', 'Manage work contracts and create buyer accounts') }
//                         ].filter(c => hasPerm(c.perm));

//                         if (cards.length === 0) return null;

//                         return (
//                             <div className="space-y-8">
//                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
//                                     {t('admin.sales_section', 'Sales & Operations')}
//                                 </h3>
//                                 {cards.map((c, i) => (
//                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
//                                 ))}
//                             </div>
//                         );
//                     })()}
//                 </div>
//             </div >
//             {/* Users Table
//             <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100">
//                 <h2 className="text-2xl font-bold mb-4">{t('admin.users_page.title', 'User Management')}</h2>
//                 <AdminUsers />
//             </div> */}
//         </>
//     )
// });

// export default Admin;








// import React, { memo, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import AdminCard from "./components/AdminCard";
// import { getToken } from "../../utils/auth";
// import { jwtDecode } from "jwt-decode";
// import axios from "axios";
// import CONFIG from "../../config";
// // import WhatsAppAdmin from "./WhatsAppAdmin";
// // import AIAdmin from "./AIAdmin";

// const Admin = memo(() => {
//     const navigate = useNavigate();
//     const { t, i18n } = useTranslation();
//     const [permissions, setPermissions] = useState([]);
//     const [isAdmin, setIsAdmin] = useState(false);
//     const [loading, setLoading] = useState(true);

//     const isArabic = i18n.language.startsWith('ar');

//     useEffect(() => {
//         const checkPerms = async () => {
//             const token = getToken();
//             if (!token) return;
//             try {
//                 // Fetch fresh permissions from the dedicated /me endpoint
//                 const res = await axios.get(`${CONFIG.API_URL}/api/admin/users/me`, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });

//                 if (res.data) {
//                     setIsAdmin(!!res.data.isAdmin);
//                     setPermissions(res.data.permissions || []);

//                     // Sync with localStorage so ProtectedRoute stays up to date
//                     const localUser = JSON.parse(localStorage.getItem("user") || "{}");
//                     localStorage.setItem("user", JSON.stringify({
//                         ...localUser,
//                         isAdmin: !!res.data.isAdmin,
//                         permissions: res.data.permissions || []
//                     }));
//                 }
//             } catch (err) {
//                 console.error("Failed to fetch fresh permissions:", err);
//                 // Fallback to token if /me fails
//                 try {
//                     const decoded = jwtDecode(token);
//                     setIsAdmin(!!decoded.isAdmin);
//                 } catch (e) { }
//             } finally {
//                 setLoading(false);
//             }
//         };
//         checkPerms();
//     }, []);

//     const hasPerm = (p) => {
//         if (loading) return false;
//         if (!isAdmin) return false;
//         if (permissions.includes('*') || permissions === '*') return true;
//         return permissions.includes(p);
//     };

//     if (loading) return <div className="p-20 text-center animate-pulse">{t('admin.common.loading_admin', 'Loading Admin Panel...')}</div>;

//     // // Check if WhatsAppAdmin should be shown (full page)
//     // if (window.location.pathname === '/admin/whatsapp') {
//     //     return <WhatsAppAdmin />;
//     // }

//     // // Check if AIAdmin should be shown (full page)
//     // if (window.location.pathname === '/admin/ai') {
//     //     return <AIAdmin />;
//     // }

//     return (
//         <>
//             <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
//                 <div className="mb-12 text-center">
//                     <h1 className="text-5xl font-black text-gray-900 tracking-tight mb-4">{t('admin.title')}</h1>
//                     <p className="text-gray-500 font-medium text-lg max-w-2xl mx-auto">{t('admin.description')}</p>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                     {/* Analytics & content */}
//                     {(() => {
//                         const cards = [
//                             { perm: 'analytics', title: t('admin.analytics'), onClick: () => navigate("/admin/analytics"), icon: "📊", description: t('admin.card_desc.analytics') },
//                             { perm: 'users', title: t('admin.users'), onClick: () => navigate("/admin/users"), icon: "👥", description: t('admin.card_desc.users') },
//                             { perm: 'profile', title: t('admin.profile'), onClick: () => navigate("/admin/profile"), icon: "👤", description: t('admin.card_desc.profile',), alwaysShow: true },
//                             { perm: '*', title: t('admin.system_logs'), onClick: () => navigate("/admin/logs"), icon: "📜", description: t('admin.card_desc.system-logs') },
//                             { perm: '*', title: t('admin.admin_secrets'), onClick: () => navigate("/admin/secrets"), icon: "🔐", description: t('admin.card_desc.admin-secrets') },
//                             { perm: '*', title: t('admin.settings.title', 'System Settings'), onClick: () => navigate("/admin/settings"), icon: "⚙️", description: t('admin.settings.subtitle', 'Unified dashboard for profiles & health') },
//                             { perm: '*', title: t('admin.tasks.title', 'Background Tasks'), onClick: () => navigate("/admin/tasks"), icon: "📊", description: t('admin.tasks.subtitle', 'Monitor and manage long-running background uploads') }
//                         ].filter(c => c.alwaysShow || hasPerm(c.perm));

//                         if (cards.length === 0) return null;

//                         return (
//                             <div className="space-y-8">
//                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
//                                     {t('admin.overview', 'Overview')}
//                                 </h3>
//                                 {cards.map((c, i) => (
//                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
//                                 ))}
//                             </div>
//                         );
//                     })()}

//                     {/* Store Content */}
//                     {(() => {
//                         const cards = [
//                             { perm: 'products', title: t('admin.products'), onClick: () => navigate("/admin/product"), icon: "🛋️", description: t('admin.card_desc.products') },
//                             { perm: 'hero', title: t('admin.hero'), onClick: () => navigate("/admin/hero"), icon: "🖼️", description: t('admin.card_desc.hero') },
//                             { perm: 'categories', title: t('admin.categories'), onClick: () => navigate("/admin/categories"), icon: "📂", description: t('admin.card_desc.categories') },
//                             { perm: 'about', title: t('admin.about'), onClick: () => navigate("/admin/about"), icon: "ℹ️", description: t('admin.card_desc.about') },
//                             { perm: '*', title: t('admin.legal.title', 'Legal Pages'), onClick: () => navigate("/admin/legal"), icon: "⚖️", description: t('admin.card_desc.legal', 'Manage Privacy Policy and Terms') },
//                             { perm: '*', title: t('admin.contact_info_title'), onClick: () => navigate("/admin/contact-info"), icon: "📞", description: t('admin.card_desc.contact_info') },
//                             { perm: '*', title: t('admin.trash', 'Trash'), onClick: () => navigate("/admin/trash"), icon: "🗑️", description: t('admin.card_desc.trash', 'Restore or permanently delete items') },
//                             { perm: '*', title: 'Orders', onClick: () => navigate("/admin/orders"), icon: "📦", description: 'Manage customer orders, track status and revenue' },
//                             { perm: '*', title: 'Wishlist Insights', onClick: () => navigate("/admin/wishlist-insights"), icon: "❤️", description: 'See which products customers save most' },
//                             { perm: '*', title: 'Cart Insights', onClick: () => navigate("/admin/cart-insights"), icon: "🛒", description: 'View active shopping carts and estimated value' },
//                         ].filter(c => hasPerm(c.perm));

//                         if (cards.length === 0) return null;

//                         return (
//                             <div className="space-y-8">
//                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
//                                     {t('admin.store_content', 'Store Content')}
//                                 </h3>
//                                 {cards.map((c, i) => (
//                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
//                                 ))}
//                             </div>
//                         );
//                     })()}

//                     {/* Customer Interaction */}
//                     {(() => {
//                         const cards = [
//                             { perm: 'messages', title: t('admin.messages'), onClick: () => navigate("/admin/messages"), icon: "💬", description: t('admin.card_desc.messages', 'Contact requests') },
//                             { perm: 'reviews', title: t('admin.reviews'), onClick: () => navigate("/admin/reviews"), icon: "⭐", description: t('admin.card_desc.reviews', 'Product ratings') },
//                             { perm: 'feedback', title: t('admin.feedback'), onClick: () => navigate("/admin/feedback"), icon: "📝", description: t('admin.card_desc.feedback', 'General feedback') },
//                             { perm: '*', title: 'WhatsApp AI', onClick: () => navigate("/admin/whatsapp"), icon: "📱", description: 'Configure WhatsApp auto-replies with AI' },
//                             { perm: '*', title: 'AI Configuration', onClick: () => navigate("/admin/ai"), icon: "🤖", description: 'Configure AI providers and settings' },
//                             { perm: '*', title: 'Magic Writer', onClick: () => navigate("/admin/magic-writer"), icon: "✨", description: 'AI-powered writing assistant for content creation' },
//                             { perm: '*', title: t('admin.instructions.title', 'Instructions'), onClick: () => navigate("/admin/instructions"), icon: "📖", description: t('admin.instructions.description', 'Guidelines for domain owners') }
//                         ].filter(c => hasPerm(c.perm));

//                         if (cards.length === 0) return null;

//                         return (
//                             <div className="space-y-8">
//                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
//                                     {t('admin.feedback_section', 'Feedback')}
//                                 </h3>
//                                 {cards.map((c, i) => (
//                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
//                                 ))}
//                             </div>
//                         );
//                     })()}

//                     {/* Master Admin Operations */}
//                     {(() => {
//                         const cards = [
//                             { perm: '*', title: t('admin.contracts.title', 'Contracts & Sales'), onClick: () => navigate("/admin/contracts"), icon: "📄", description: t('admin.contracts.description', 'Manage work contracts and create buyer accounts') }
//                         ].filter(c => hasPerm(c.perm));

//                         if (cards.length === 0) return null;

//                         return (
//                             <div className="space-y-8">
//                                 <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
//                                     {t('admin.sales_section', 'Sales & Operations')}
//                                 </h3>
//                                 {cards.map((c, i) => (
//                                     <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
//                                 ))}
//                             </div>
//                         );
//                     })()}
//                 </div>
//             </div >
//         </>
//     )
// });

// export default Admin;








// ====================================
// New work isMaster
// ====================================




import React, { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminCard from "./components/AdminCard";
import { getToken, getUser } from "../../utils/auth";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import CONFIG from "../../config";
import { Helmet } from "react-helmet-async";
import SEO from "../../components/common/SEO";
// import WhatsAppAdmin from "./WhatsAppAdmin";
// import AIAdmin from "./AIAdmin";
// Import AdminUsers component
// import AdminUsers from "./AdminUsers";

const Admin = memo(() => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [permissions, setPermissions] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isMaster, setIsMaster] = useState(false);
    const [loading, setLoading] = useState(true);

    const isArabic = i18n.language.startsWith('ar');

    useEffect(() => {
        const MASTER_PROFILE_ID = 'prof_01JK0000000000000000000001';
        const computeIsMaster = (data) => {
            const perms = data.permissions || [];
            const hasStar = Array.isArray(perms) ? perms.includes('*') : perms === '*';
            return hasStar && (!data.profile_id || data.profile_id === MASTER_PROFILE_ID);
        };

        const checkPerms = async () => {
            const token = getToken();
            if (!token) return;
            try {
                // Fetch fresh permissions from the dedicated /me endpoint
                const res = await axios.get(`${CONFIG.API_URL}/api/admin/users/me`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (res.data) {
                    const master = computeIsMaster(res.data);
                    setIsAdmin(!!res.data.isAdmin);
                    setIsMaster(master);
                    setPermissions(res.data.permissions || []);

                    // Sync with localStorage so ProtectedRoute & Header stay up to date
                    const localUser = JSON.parse(localStorage.getItem("user") || "{}");
                    localStorage.setItem("user", JSON.stringify({
                        ...localUser,
                        isAdmin: !!res.data.isAdmin,
                        isMaster: master,
                        permissions: res.data.permissions || []
                    }));
                    // Notify Header (and any other listener) about the updated user
                    window.dispatchEvent(new Event('user_changed'));
                }
            } catch (err) {
                console.error("Failed to fetch fresh permissions:", err);
                // Fallback to token if /me fails
                try {
                    const decoded = jwtDecode(token);
                    setIsAdmin(!!decoded.isAdmin);
                } catch (e) { }
            } finally {
                setLoading(false);
            }
        };
        checkPerms();
    }, []);

    const hasPerm = (p) => {
        if (loading) return false;
        if (!isAdmin) return false;
        if (permissions.includes('*') || permissions === '*') return true;
        return permissions.includes(p);
    };


    useEffect(() => {
        const check = () => {
            try {
                const u = getUser();
                // setUserState(u);
                setIsMaster(!!u?.isMaster);
            } catch (e) {
                // setUserState(null);
                setIsMaster(false);
            }
        };

        check();

        // const onStorage = (e) => {
        //   if (e.key === 'user') check();
        // };

        const onCustom = () => check();

        // window.addEventListener('storage', onStorage);
        window.addEventListener('user_changed', onCustom);
        return () => {
            // window.removeEventListener('storage', onStorage);
            window.removeEventListener('user_changed', onCustom);
        };
    }, []);

    if (loading) return <div className="p-20 text-center animate-pulse">{t('admin.common.loading_admin', 'Loading Admin Panel...')}</div>;

    // // Check if WhatsAppAdmin should be shown (full page)
    // if (window.location.pathname === '/admin/whatsapp') {
    //     return <WhatsAppAdmin />;
    // }

    // // Check if AIAdmin should be shown (full page)
    // if (window.location.pathname === '/admin/ai') {
    //     return <AIAdmin />;
    // }

    return (
        <>
            <Helmet>
                <html lang={isArabic ? 'ar' : 'en'} dir={isArabic ? 'rtl' : 'ltr'} />
            </Helmet>
            <SEO />
            <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
                <div className="mb-12 text-center">
                    <h1 className="text-5xl font-black text-gray-900 tracking-tight mb-4">{t('admin.title')}</h1>
                    <p className="text-gray-500 font-medium text-lg max-w-2xl mx-auto">{t('admin.description')}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Analytics & content */}
                    {(() => {
                        const cards = [
                            { perm: 'analytics', title: t('admin.analytics'), onClick: () => navigate("/admin/analytics"), icon: "📊", description: t('admin.card_desc.analytics') },
                            { perm: 'users', title: t('admin.users'), onClick: () => navigate("/admin/users"), icon: "👥", description: t('admin.card_desc.users') },
                            { perm: 'profile', title: t('admin.profile'), onClick: () => navigate("/admin/profile"), icon: "👤", description: t('admin.card_desc.profile',), alwaysShow: true },
                            { perm: '*', title: t('admin.system_logs'), onClick: () => navigate("/admin/logs"), icon: "📜", description: t('admin.card_desc.system-logs') },
                            { perm: '*', title: t('admin.admin_secrets'), onClick: () => navigate("/admin/secrets"), icon: "🔐", description: t('admin.card_desc.admin-secrets') },
                            // { perm: '*', title: t('admin.breach_logs', 'Data Breach Logs'), onClick: () => navigate("/admin/compliance/breaches"), icon: "🚨", description: t('admin.breach_subtitle', '72-Hour Transparency Compliance Audit Trail') },
                            { perm: '*', title: t('admin.settings.title', 'System Settings'), onClick: () => navigate("/admin/settings"), icon: "⚙️", description: t('admin.settings.subtitle', 'Unified dashboard for profiles & health') },
                            { perm: '*', title: t('admin.tasks.title', 'Background Tasks'), onClick: () => navigate("/admin/tasks"), icon: "📊", description: t('admin.tasks.subtitle', 'Monitor and manage long-running background uploads') },
                            // { perm: '*', title: t('admin.data_subject_rights', 'Data Subject Rights'), onClick: () => navigate("/admin/compliance/data-subject"), icon: "🛡️", description: t('admin.data_subject_rights_desc', 'Manage user data access, rectification, erasure, consent & breach notifications') }
                        ].filter(c => c.alwaysShow || hasPerm(c.perm));

                        if (cards.length === 0) return null;

                        return (
                            <div className="space-y-8">
                                <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
                                    {t('admin.overview', 'Overview')}
                                </h3>
                                {cards.map((c, i) => (
                                    <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
                                ))}
                            </div>
                        );
                    })()}

                    {/* Store Content */}
                    {(() => {
                        const cards = [
                            { perm: 'products', title: t('admin.products'), onClick: () => navigate("/admin/product"), icon: "🛋️", description: t('admin.card_desc.products') },
                            { perm: 'hero', title: t('admin.hero'), onClick: () => navigate("/admin/hero"), icon: "🖼️", description: t('admin.card_desc.hero') },
                            { perm: 'categories', title: t('admin.categories'), onClick: () => navigate("/admin/categories"), icon: "📂", description: t('admin.card_desc.categories') },
                            { perm: 'about', title: t('admin.about'), onClick: () => navigate("/admin/about"), icon: "ℹ️", description: t('admin.card_desc.about') },
                            { perm: '*', title: t('admin.legal.title', 'Legal Pages'), onClick: () => navigate("/admin/legal"), icon: "⚖️", description: t('admin.card_desc.legal', 'Manage Privacy Policy and Terms') },
                            { perm: '*', title: t('admin.contact_info_title'), onClick: () => navigate("/admin/contact-info"), icon: "📞", description: t('admin.card_desc.contact_info') },
                            { perm: '*', title: t('admin.trash', 'Trash'), onClick: () => navigate("/admin/trash"), icon: "🗑️", description: t('admin.card_desc.trash', 'Restore or permanently delete items') },
                            { perm: '*', title: 'Orders', onClick: () => navigate("/admin/orders"), icon: "📦", description: 'Manage customer orders, track status and revenue' },
                            { perm: '*', title: 'Wishlist Insights', onClick: () => navigate("/admin/wishlist-insights"), icon: "❤️", description: 'See which products customers save most' },
                            { perm: '*', title: 'Cart Insights', onClick: () => navigate("/admin/cart-insights"), icon: "🛒", description: 'View active shopping carts and estimated value' },
                        ].filter(c => hasPerm(c.perm));

                        if (cards.length === 0) return null;

                        return (
                            <div className="space-y-8">
                                <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
                                    {t('admin.store_content', 'Store Content')}
                                </h3>
                                {cards.map((c, i) => (
                                    <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
                                ))}
                            </div>
                        );
                    })()}

                    {/* Customer Interaction */}
                    {(() => {
                        const cards = [
                            { perm: 'messages', title: t('admin.messages'), onClick: () => navigate("/admin/messages"), icon: "💬", description: t('admin.card_desc.messages', 'Contact requests') },
                            { perm: 'reviews', title: t('admin.reviews'), onClick: () => navigate("/admin/reviews"), icon: "⭐", description: t('admin.card_desc.reviews', 'Product ratings') },
                            { perm: 'feedback', title: t('admin.feedback'), onClick: () => navigate("/admin/feedback"), icon: "📝", description: t('admin.card_desc.feedback', 'General feedback') },
                            { perm: '*', title: 'WhatsApp AI', onClick: () => navigate("/admin/whatsapp"), icon: "📱", description: 'Configure WhatsApp auto-replies with AI' },
                            { perm: '*', title: 'AI Configuration', onClick: () => navigate("/admin/ai"), icon: "🤖", description: 'Configure AI providers and settings' },
                            { perm: '*', title: 'Magic Writer', onClick: () => navigate("/admin/magic-writer"), icon: "✨", description: 'AI-powered writing assistant for content creation' },
                            { perm: '*', title: t('admin.instructions.title', 'Instructions'), onClick: () => navigate("/admin/instructions"), icon: "📖", description: t('admin.instructions.description', 'Guidelines for domain owners') },
                            // { perm: '*', title: t('admin.communication_channel'), onClick: () => navigate("/admin/compliance/communication-channel"), icon: "📡", description: t('admin.card_desc.communication_channel', 'Generate public communication channel IDs') },
                            // { perm: '*', title: t('admin.channel_wizard'), onClick: () => navigate("/admin/channel-wizard"), icon: "🪄", description: t('admin.card_desc.channel_wizard', 'Create a new communication channel') }
                        ].filter(c => hasPerm(c.perm));

                        if (cards.length === 0) return null;

                        return (
                            <div className="space-y-8">
                                <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
                                    {t('admin.feedback_section', 'Feedback')}
                                </h3>
                                {cards.map((c, i) => (
                                    <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
                                ))}
                            </div>
                        );
                    })()}

                    {/* Master Admin Operations */}
                    {isMaster && (() => {
                        const cards = [
                            { perm: '*', title: t('admin.contracts.title', 'Contracts & Sales'), onClick: () => navigate("/admin/contracts"), icon: "📄", description: t('admin.contracts.description', 'Manage work contracts and create buyer accounts') }
                        ].filter(c => hasPerm(c.perm));

                        if (cards.length === 0) return null;

                        return (
                            <div className="space-y-8">
                                <h3 className={isArabic ? "text-sm font-black text-gray-400 uppercase tracking-widest mr-4" : "text-sm font-black text-gray-400 uppercase tracking-widest ml-4"}>
                                    {t('admin.sales_section', 'Sales & Operations')}
                                </h3>
                                {cards.map((c, i) => (
                                    <AdminCard key={i} title={c.title} onClick={c.onClick} icon={c.icon} description={c.description} />
                                ))}
                            </div>
                        );
                    })()}
                </div>
            </div >
            {/* Users Table
            <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100">
                <h2 className="text-2xl font-bold mb-4">{t('admin.users_page.title', 'User Management')}</h2>
                <AdminUsers />
            </div> */}
        </>
    )
});

export default Admin;